export default class Environment {
    static BaseAPIURL = "https://bialpaxexituatapi.maxworth.in/api/BialPaxExit";
}